export const SERVICE_SLUGS = ["on-premise-ai", "custom-ai", "secure-infrastructure"];

export const STRINGS = {
  en: {
    nav: { about: "About Us", services: "Services", why: "Why Us", contact: "Contact" },
    cta: "Get Started",
    kicker: "Practical & Secure AI Solutions",
    tagline: "intelligence beyond earth",
    heroH2: "Strategic AI as a Business Asset",
    heroP1: "We empower enterprises with scalable AI systems that improve efficiency,",
    heroP2: "reduce costs, and accelerate growth.",
    ourServices: "Our Services",
    stats: ["UPTIME", "ENTERPRISE CLIENTS", "SUPPORT"],
    trust: ["Secure", "Fast", "Global", "Private"],
    aboutLabel: "01 / About VIRA",
    aboutH2: ["Intelligence that works", "in the real world."],
    aboutP: "VIRA turns advanced intelligence into practical advantage. We design secure, scalable systems that fit the way modern enterprises actually operate — bringing clarity to complexity and momentum to every decision.",
    servicesLabel: "02 / What we do",
    servicesH2: ["Built for the", "next frontier."],
    servicesP: "From first signal to full-scale deployment, our systems are engineered to create durable business value.",
    services: [
      { title: "On-Premise AI", text: "Private AI systems built for control, security, and sensitive enterprise workflows." },
      { title: "Custom AI", text: "Purpose-built intelligence that connects your teams, data, and decisions." },
      { title: "Secure Infrastructure", text: "Fast, resilient foundations that keep your most important operations moving." },
    ],
    explore: "Explore service",
    industriesH2: "Industries We Serve",
    industries: ["Finance", "Healthcare", "Retail", "Manufacturing", "Logistics", "Security"],
    industriesNote: "Don't see your industry? We work with businesses across all sectors.",
    industriesCta: "Discuss Your Needs",
    whyLabel: "03 / Why VIRA",
    whyH2: ["The advantage is", "staying ahead."],
    whyP: "Technology moves fast. Your infrastructure should move faster. VIRA pairs rigorous engineering with a clear understanding of your business, so every system is designed for what comes next.",
    featureSub: "Built into everything we do",
    contactLabel: "04 / Let’s talk",
    contactH2: ["Make your next move", "the intelligent one."],
    contactCta: "Start a conversation",
    footerTag: "© 2025 VIRA. Intelligence beyond earth.",
    modalEyebrow: "Start a conversation",
    modalH2: "Build what’s next.",
    modalP: "Tell us where intelligence can move your business forward.",
    namePh: "Your name",
    emailPh: "Work email",
    messagePh: "How can we help?",
    send: "Send inquiry",
    sending: "Sending…",
    successH2: "Message received.",
    successP: "Our team will be in touch shortly.",
    done: "Done",
    formError: "Something went wrong. Please try again.",
    title: "VIRA — Intelligence Beyond Earth",
    servicePages: {
      "on-premise-ai": {
        eyebrow: "Service 01 — On-Premise AI",
        title: "On-Premise AI",
        tagline: "Your data never leaves your walls.",
        p1: "We build AI systems that run entirely inside your own infrastructure — no external cloud, no shared data pipelines, no surprises. You keep full control from installation to daily operation.",
        p2: "Ideal for government, finance, healthcare, and every organization whose sensitive data cannot leave its perimeter.",
        features: ["Full data sovereignty", "Compliance-ready for local regulations", "Runs offline and air-gapped", "Hardware tuned to your workloads", "Deep integration with internal systems", "Predictable operating costs"],
        cta: "Discuss On-Premise AI",
        back: "All services",
      },
      "custom-ai": {
        eyebrow: "Service 02 — Custom AI",
        title: "Custom AI",
        tagline: "Intelligence shaped around your business — not the other way around.",
        p1: "No off-the-shelf products, no generic templates. We study how your teams actually work, then design models and AI systems that serve your exact goals — from process automation to decision support.",
        p2: "Every system we deliver ships fully integrated with your current tools, with your team trained to run it.",
        features: ["Models trained on your domain data", "Everyday workflow automation", "Integration-ready APIs", "Impact dashboards and reporting", "Team training and enablement", "Continuous improvement after launch"],
        cta: "Discuss Custom AI",
        back: "All services",
      },
      "secure-infrastructure": {
        eyebrow: "Service 03 — Secure Infrastructure",
        title: "Secure Infrastructure",
        tagline: "Foundations built for always-on operations.",
        p1: "Performance and security are never an afterthought — they are the starting point. We design fast, resilient infrastructure that protects your most sensitive operations and scales with you.",
        p2: "From encryption to disaster recovery, every layer is engineered so your business keeps moving, whatever happens.",
        features: ["End-to-end encryption in transit and at rest", "99.9% uptime architecture", "24/7 monitoring and response", "Disaster recovery planning", "Instant scalability", "Regular audits and penetration testing"],
        cta: "Discuss Secure Infrastructure",
        back: "All services",
      },
    },
  },
  ar: {
    nav: { about: "من نحن", services: "خدماتنا", why: "لماذا نحن", contact: "تواصل معنا" },
    cta: "ابدأ الآن",
    kicker: "حلول ذكاء اصطناعي عملية وآمنة",
    tagline: "ذكاء يتجاوز حدود الأرض",
    heroH2: "الذكاء الاصطناعي الاستراتيجي كأصل لأعمالك",
    heroP1: "نمكّن المؤسسات بأنظمة ذكاء اصطناعي قابلة للتوسع ترفع الكفاءة،",
    heroP2: "وتخفض التكاليف، وتسرّع النمو.",
    ourServices: "خدماتنا",
    stats: ["الجاهزية", "عميل من المؤسسات", "دعم متواصل"],
    trust: ["آمن", "سريع", "عالمي", "خاص"],
    aboutLabel: "01 / عن VIRA",
    aboutH2: ["ذكاءٌ يعمل", "في العالم الحقيقي."],
    aboutP: "تحوّل VIRA الذكاء المتقدم إلى ميزة عملية. نصمم أنظمة آمنة وقابلة للتوسع تناسب طريقة عمل المؤسسات الحديثة فعلياً — فنضيف الوضوح إلى التعقيد والزخم إلى كل قرار.",
    servicesLabel: "02 / ماذا نقدم",
    servicesH2: ["نبني من أجل", "الحدود القادمة."],
    servicesP: "من الإشارة الأولى إلى النشر الكامل، أنظمتنا مصممة لخلق قيمة تجارية دائمة.",
    services: [
      { title: "ذكاء اصطناعي محلي", text: "أنظمة ذكاء اصطناعي خاصة مصممة للتحكم والأمان وسير العمل المؤسسي الحساس." },
      { title: "ذكاء اصطناعي مخصص", text: "ذكاء مصمم خصيصاً يربط فرقك وبياناتك وقراراتك." },
      { title: "بنية تحتية آمنة", text: "أسس سريعة ومرنة تحافظ على استمرار أهم عملياتك." },
    ],
    explore: "اكتشف الخدمة",
    industriesH2: "القطاعات التي نخدمها",
    industries: ["المالية", "الرعاية الصحية", "التجزئة", "التصنيع", "الخدمات اللوجستية", "الأمن"],
    industriesNote: "لا ترى قطاعك؟ نعمل مع الشركات في جميع المجالات.",
    industriesCta: "ناقش احتياجاتك",
    whyLabel: "03 / لماذا VIRA",
    whyH2: ["الميزة هي", "البقاء في المقدمة."],
    whyP: "التقنية تتحرك بسرعة، وبنيتك التحتية يجب أن تكون أسرع. تجمع VIRA بين الهندسة الدقيقة والفهم الواضح لأعمالك، بحيث يُصمم كل نظام لما هو قادم.",
    featureSub: "مدمجة في كل ما نقوم به",
    contactLabel: "04 / لنتحدث",
    contactH2: ["اجعل خطوتك القادمة", "هي الأذكى."],
    contactCta: "ابدأ المحادثة",
    footerTag: "© 2025 VIRA. ذكاء يتجاوز حدود الأرض.",
    modalEyebrow: "ابدأ محادثة",
    modalH2: "لنبنِ القادم.",
    modalP: "أخبرنا كيف يمكن للذكاء الاصطناعي أن يدفع أعمالك إلى الأمام.",
    namePh: "الاسم",
    emailPh: "البريد الإلكتروني للعمل",
    messagePh: "كيف يمكننا مساعدتك؟",
    send: "إرسال الاستفسار",
    sending: "جارٍ الإرسال…",
    successH2: "تم استلام رسالتك.",
    successP: "سيتواصل معك فريقنا قريباً.",
    done: "تم",
    formError: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    title: "VIRA — ذكاء يتجاوز حدود الأرض",
    servicePages: {
      "on-premise-ai": {
        eyebrow: "الخدمة 01 — ذكاء اصطناعي محلي",
        title: "ذكاء اصطناعي محلي",
        tagline: "بياناتك لا تغادر جدران مؤسستك أبداً.",
        p1: "نبني أنظمة ذكاء اصطناعي تعمل بالكامل داخل بنيتك التحتية الخاصة — لا سحابة خارجية، لا مشاركة بيانات، لا مفاجآت. تحتفظ بالتحكم الكامل من التثبيت حتى التشغيل اليومي.",
        p2: "مثالية للجهات الحكومية والمالية والصحية، ولكل مؤسسة تتعامل مع بيانات حساسة لا يمكن أن تغادر نطاقها.",
        features: ["سيادة كاملة على البيانات", "جاهزية للمتطلبات التنظيمية المحلية", "تعمل دون اتصال بالإنترنت", "عتاد مضبوط على أحمال عملك", "تكامل عميق مع أنظمتك الداخلية", "تكاليف تشغيل ثابتة ومتوقعة"],
        cta: "ناقش الذكاء المحلي",
        back: "كل الخدمات",
      },
      "custom-ai": {
        eyebrow: "الخدمة 02 — ذكاء اصطناعي مخصص",
        title: "ذكاء اصطناعي مخصص",
        tagline: "ذكاء مصمم حول أعمالك — وليس العكس.",
        p1: "لا منتجات جاهزة ولا قوالب عامة. ندرس طريقة عمل فرقك فعلياً، ثم نصمم نماذج وأنظمة ذكاء اصطناعي تخدم أهدافك بدقة — من أتمتة العمليات إلى دعم القرار.",
        p2: "كل نظام نسلّمه يأتي متكاملاً بالكامل مع أدواتك الحالية، مع تدريب فريقك على تشغيله.",
        features: ["نماذج مدرّبة على بيانات مجالك", "أتمتة سير العمل اليومي", "واجهات برمجية جاهزة للتكامل", "لوحات قياس الأثر والتقارير", "تدريب وتمكين فريقك", "تحسين مستمر بعد الإطلاق"],
        cta: "ناقش الذكاء المخصص",
        back: "كل الخدمات",
      },
      "secure-infrastructure": {
        eyebrow: "الخدمة 03 — بنية تحتية آمنة",
        title: "بنية تحتية آمنة",
        tagline: "أسس بُنيت لتعمل دون توقف.",
        p1: "الأداء والأمان ليسا إضافة لاحقة — هما نقطة البداية. نصمم بنية تحتية سريعة ومرنة تحمي عملياتك الأكثر حساسية وتنمو معك.",
        p2: "من التشفير إلى التعافي من الكوارث، كل طبقة مهندَسة لتبقى أعمالك تتحرك مهما حدث.",
        features: ["تشفير كامل أثناء النقل والتخزين", "معمارية جاهزية 99.9%", "مراقبة واستجابة على مدار الساعة", "خطط التعافي من الكوارث", "قابلية توسع فورية", "مراجعات واختبارات اختراق دورية"],
        cta: "ناقش البنية الآمنة",
        back: "كل الخدمات",
      },
    },
  },
};
